import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
    apiKey: "AIzaSyD01NshjAr5YgNeIoRVQ9DqYeJ_ZFYNkHA",
    authDomain: "rifasapp-beta.firebaseapp.com",
    projectId: "rifasapp-beta",
    storageBucket: "rifasapp-beta.appspot.com",
    messagingSenderId: "414449779365",
    appId: "1:414449779365:web:074aa9c36f42d28a78834c"
};

const app = initializeApp(firebaseConfig);
const db = getFirestore(app);
const authFB = getAuth(app);
const storage = getStorage(app);

export { db, authFB, storage };
